import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class AssetService extends RLBaseService {

    static $inject = ["$resource"];

    constructor(private $resource: ng.resource.IResourceService) {
        super($resource);
    }

    getAssociatedAssets(query: Models.ISearchRequest) {
        return this.toRLService<Models.IAssetSearchResult>("/api/asset/getassociatedassets/").post(query).$promise;
    }

    executeWorkflow(actionId: number, assetIds: number[]) {
        return this.toRLService<Models.IExecuteAssetWorkflowResults>("/api/asset/executeworkflow").post({ actionID: actionId, assetIDs: assetIds }).$promise;
    }

    getHierarchy(assetId: number, showInventory: boolean) {
        var data = {
            id: assetId,
            showInventory: showInventory
        };
        return this.toRLService<Models.IEntityNode>("/api/asset/getassethierarchy/:id", { id: "@id" }).get(data).$promise;
    }

    deleteAssociations(assetId: number, relRecIDs: number[]) {
        var data = {
            parentRecID: assetId,
            relRecIDs: relRecIDs
        };
        return this.toRLService<boolean>("/api/asset/deleteassociations").post(data).$promise;
    }

    createAssociations(assetID: number, childRecIDs: number[]) {
        var data = {
            parentRecID: assetID,
            childRecIDs: childRecIDs
        };
        return this.toRLService<boolean>("/api/asset/createassociations").post(data).$promise;
    }

    searchEntityAssets(parentEntityID: string, parentAssetID: number, page: number, rows: number) {
        var data = {
            parentEntityID: parentEntityID,
            parentAssetID: parentAssetID,
            page: page,
            rows: rows
        };
        return this.toRLService<Models.ISearchContractAssetsResponse>("/api/asset/searchentityassets").post(data).$promise;
    }

    anyRemainingCatalogComponents(parentEntityID: string, removedComponentID: string, catalogItemID: string) {
        var data = {
            parentEntityID: parentEntityID,
            removedComponentID: removedComponentID,
            catalogItemID: catalogItemID
        };
        return this.toRLService<Models.IDataResponse<boolean>>("/api/asset/anyremainingcatalogcomponents").post(data).$promise;

    }

    getCatalogItemsWithNoComponents(removedComponentTriple: Models.IRemovedComponentTriple[]) {

        return this.toRLService<Models.IDataResponse<Models.IEntity[]>>("/api/asset/getcatalogitemswithnocomponents").post(removedComponentTriple).$promise;

    }
}
